export default __webpack_public_path__ + "static/Tek_Staircase-7803360fb87fdeba839e04092e827847.png";